import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { VoiceCloneCreatorOptions } from "../base/VoiceCloneSynthesis";
import { MISSION_CONFIG } from "./missionConfig";

function MissionVoice(props) {
  const missionName = props.missionData ? props.missionData.name : 'Unknown Mission';

  const voiceConfig = useMemo(() => ({
    ...MISSION_CONFIG.voice,
    placeholder: "CAPCOM Transmission text will appear here automatically...",
    synthesisHelper: (switchTab, setPendingGptPrompt) => (
      <p className="mb-2" style={{ fontSize: "14px", color: "#555" }}>
        Return to{" "}
        <Button
          className="btn-nav-link"
          onClick={() => {
            switchTab('gpt');
            if (setPendingGptPrompt) {
              setPendingGptPrompt(2);
            }
          }}
          style={{
            margin: "0 4px",
            padding: "2px 10px",
            fontSize: "13px",
            display: "inline",
            whiteSpace: "nowrap",
            backgroundColor: "white",
            borderColor: "#f05f40",
            color: "#f05f40",
            verticalAlign: "baseline",
          }}
        >
          Text
        </Button>{" "}
        and create a CAPCOM Transmission, it will appear here automatically.
      </p>
    ),
    hideSlideshow: true,
    instructionText: "Select",
    instructionTextAfter: <> to design the next generation of <span style={{ color: "#f05f40", fontWeight: "bold" }}>{missionName}</span> with new technology, upgraded systems, and objectives.</>,
    nextStepButtonText: "Text",
    nextStepTab: "gpt",
    nextStepPromptIndex: 3,
  }), [missionName]);

  return (
    <VoiceCloneCreatorOptions
      {...props}
      workshopConfig={voiceConfig}
    />
  );
}

export { MissionVoice };
